// Payment related constants

export const SETTLEMENT_REQUEST_MIN_AMOUNT = 1;
export const ACCOUNT_LAST_DIGITS_LENGTH = 5;
